// assets
import { IconTypography, IconPalette, IconShadow, IconWindmill } from '@tabler/icons';
import ReceiptIcon from '@mui/icons-material/Receipt';
import HelpCenterIcon from '@mui/icons-material/HelpCenter';
import FactCheckIcon from '@mui/icons-material/FactCheck';

// constant
const icons = {
    IconTypography,
    IconPalette,
    IconShadow,
    IconWindmill
};





const utilities = {
    id: 'Operations',
    title: 'Operations',
    type: 'group',
    children: [
        {
            id: 'AddEssay',
            title: 'Add Essay',
            type: 'item',
            url: '/Operations/AddEssay',
            icon: ReceiptIcon,
            breadcrumbs: false
        },
        {
            id: 'AddQuiz',
            title: 'Add Quiz',
            type: 'item',
            url: '/Operations/AddQuiz',
            icon: HelpCenterIcon,
            breadcrumbs: false
        },
        {
            id: 'Announcement',
            title: 'Add Announcement',
            type: 'item',
            url: '/Operations/Announcement',
            icon: ReceiptIcon,
            breadcrumbs: false
        },
    ]
};



export default utilities;
